
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.584 5.26a.9.9 0 011.264 1.281l-5.27 5.2a.9.9 0 01-1.27-.007l-5.163-5.2a.9.9 0 011.277-1.268l4.53 4.563 4.632-4.57z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    